module.exports = __webpack_public_path__ + "files/3242e1c7686e5cd82a62a3fc45b0897a.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/droidserif-bolditalic-webfont.ttf
 ** module id = 899
 ** module chunks = 0
 **/